import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '../ui/card';
import { Slider } from '../ui/slider';
import { fadeUp, displaySection, kicker, sectionWrap, sectionInner } from './shared';

const ROWS = [
  ['Generic headline', 'Clear role + value positioning'],
  ['About reads like a resume', 'About reads like a confident pro story'],
  ['Achievements buried', 'Impact visible quickly'],
  ['Content feels random', 'Content follows clear themes'],
  ['Profile attracts little attention', 'Profile supports discovery + trust'],
  ['You sound like everyone else', 'You sound more like yourself'],
];

export const BeforeAfterSection = () => {
  const [reveal, setReveal] = useState([55]);
  const pct = reveal[0];
  return (
    <section className={sectionWrap} id="before-after" aria-label="Before and after">
      <div className={sectionInner}>
        <motion.div {...fadeUp} className="mb-12 max-w-3xl">
          <p className={kicker}>Before / After</p>
          <h2 className={`${displaySection} mt-4 text-4xl sm:text-5xl lg:text-6xl`}>
            From passive profile to <span className="text-primary">active opportunity signal.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg text-muted-foreground leading-relaxed max-w-2xl">
            Drag the slider to compare. Real transformations from real audits.
          </p>
        </motion.div>

        <Card className="rounded-3xl border border-border/70 bg-card/80 backdrop-blur overflow-hidden" data-testid="before-after-section">
          <CardContent className="p-6 sm:p-10">
            <div className="grid sm:grid-cols-2 gap-5">
              <div
                className="rounded-2xl border border-border/60 bg-muted/30 p-6"
                data-testid="before-text"
                style={{ opacity: Math.max(0.3, 1 - pct / 100) }}
              >
                <p className="text-[10px] font-mono-edge tracking-[0.22em] uppercase text-muted-foreground mb-4">Before</p>
                {ROWS.map((r, i) => (
                  <p key={i} className="text-sm text-muted-foreground line-through decoration-muted-foreground/40 py-1.5">
                    {r[0]}
                  </p>
                ))}
              </div>
              <div
                className="rounded-2xl border border-primary/30 bg-card p-6 shadow-sm"
                data-testid="after-text"
                style={{ opacity: Math.max(0.3, pct / 100) }}
              >
                <p className="text-[10px] font-mono-edge tracking-[0.22em] uppercase text-primary mb-4">After</p>
                {ROWS.map((r, i) => (
                  <p key={i} className="text-sm font-medium py-1.5 text-foreground">
                    {r[1]}
                  </p>
                ))}
              </div>
            </div>
            <div className="mt-8 max-w-md">
              <p className="text-[10px] font-mono-edge tracking-[0.22em] uppercase text-muted-foreground">
                Before ⟷ After — <span className="tabular-nums text-foreground">{pct}%</span>
              </p>
              <Slider
                value={reveal}
                onValueChange={setReveal}
                min={0}
                max={100}
                step={1}
                className="mt-3"
                data-testid="before-after-slider"
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
